import React from 'react';
import './index.scss';

import logoRecruit from 'assets/logo-hd.png';
import SpButtonArea from 'components/molecules/SpButtonArea';

const SpFooter = ({
  onClickMainButton = {},
  nextUrl,
  prevUrl,
  valid,
  buttonType,
}) => (
  <div className="SpFooter">
    <div className="button-area">
      <SpButtonArea
        onClickMainButton={onClickMainButton}
        prevUrl={prevUrl}
        nextUrl={nextUrl}
        buttonType={buttonType}
        valid={valid}
      />
    </div>
    <div className="sp-footer-horizon" />
    <div className="sp-footer-wrapper">
      <div className="map-area">
        <ul className="url-area">
          <li>
            <a href="/sol/op61/sd01/">
              MyPageログイン
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
          <li>
            <a href="/sol/op53/sd01/">
              お問い合わせ
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
          <li>
            <a href="/sol/cont/site_map1/">
              サイトマップ
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
          <li>
            <a href="/sol/cont/privacy/">
              プライバシーポリシー
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
          <li>
            <a href="/sol/cont/terms/">
              ご利用にあたって
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
          <li>
            <a href="/corporate/">
              コーポレートサイト
              <span>＞</span>
            </a>
          </li>
          <div className="url-horizon" />
        </ul>
      </div>
      <div className="logo-area">
        <a href="/corporate/" target="_blank" rel="noopener noreferrer">
          <img className="logo-recruit" src={logoRecruit} alt="logo-recruit" />
        </a>
      </div>
    </div>
  </div>
);

export default SpFooter;